import * as React from 'react'

import clx from 'classnames'

// import { ChevronDownIcon } from '../icons/ChevronDown'
// import { CheckIcon } from '../icons/Check'

import { Switch } from '@/ui/form/primitives/Switch'

type Props = {
  label?: string
  placeholder?: string
  icon?: React.ElementType
  checked?: boolean
  labelChecked?: string
  labelUnChecked?: string
  className?: string
  value?: string
  error?: string | boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleChange?: (v: boolean) => void
  name?: string
  disabled?: boolean
  children?: React.ReactNode
}

export const FieldsetSwitch = ({
  label,
  value,
  name,
  placeholder,
  checked,
  onChange,
  handleChange,
  error,
  className,
  disabled = false,
  children,
}: Props) => {
  const hasError = Boolean(error)

  return (
    <fieldset className={clx("tw-d-form-control tw-w-full", className)}>
      {label && (
        <label className="tw-mb-0 tw-px-1 tw-pb-0.5 tw-text-sm tw-font-medium">
          {label}
        </label>
      )}
      <Switch
        checked={checked}
        value={value || ''}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
      />

      {hasError && typeof error === 'string' && (
        <span className="tw-text-xs tw-font-medium tw-text-error peer-focus-within:tw-opacity-0">
          {error}
        </span>
      )}

      {children && (<div>{children}</div>)}
    </fieldset>
  )
}
